import React from 'react';

const ProfileImage = ({ image, children, optionalClassNames }) => (
  <div
    className={`profile-image${optionalClassNames ? ' ' + optionalClassNames : ''}`}
    style={{backgroundImage: `url(${image})`}}
  >
    { children }
  </div>
)

export default ProfileImage;



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileImage.js